import { ExclamationMark } from '@hqo/react-components-library/dist/icons';
import { Button } from '@hqo/react-components-library/dist/atoms/button';
import { PaymentMethod } from '@hqo/react-components-library/dist/payment/payment-method';
import { SMALL_DEVICE_MAX_WIDTH } from 'hooks/use-is-small-viewport-width.hook';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

/*
 * The checkout CTA, pinned to the bottom on anything that is not the desktop dialog.
 *
 * ⛔ THE BOUNDARY IS `SMALL_DEVICE_MAX_WIDTH`, NOT `QUICK_CHECKOUT_BREAK_POINT`. Those are 768 and 542,
 * and the gap between them was an orphan band: too wide for the pinned footer below, too narrow for
 * the desktop rule above, so between 543 and 768 the control was neither — a half-width button
 * floating mid-sheet under a 40px hole. 768 is the same line `useIsSmallViewportWidth` draws to
 * choose a sheet over a modal, so the CTA now changes shape exactly where its container does.
 *
 * The `QUICK_CHECKOUT_BREAK_POINT` rules elsewhere in this feature are left alone — they size
 * content, not this control, and 542 may well be right for them.
 */
export const ButtonContainer = styled.div`
  @media only screen and (max-width: ${SMALL_DEVICE_MAX_WIDTH}px) {
    background: ${({ theme }) => theme.colors.$white};
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 0 15px 10px 15px;
    z-index: 15;
  }
`;

export const StyledButton = styled(Button)<{ isNativePayment: boolean }>`
  width: 215px;
  height: 48px;
  border-color: ${({ theme }) => theme.colors.greys.darkGrey6};
  margin-left: auto;
  align-self: flex-end;
  justify-content: center;
  -webkit-tap-highlight-color: transparent;
  ${({ isNativePayment }) =>
    isNativePayment &&
    `background-color: black;

    &:hover:not([disabled]),
    &:focus:not([disabled]) {
      opacity: 0.9;
      background-color: black;
      border-color: black;
  }
`}

  ${({ isNativePayment }) =>
    isNativePayment &&
    `
    &:hover:not([disabled]),
    &:focus:not([disabled]) {
      opacity: 0.9;
      background-color: black;
      border-color: black;
  }
`}

  /* Full width wherever the container above is a footer, so the two agree on where the CTA changes. */
  @media only screen and (max-width: ${SMALL_DEVICE_MAX_WIDTH}px) {
    width: 100%;
    height: 48px;
    margin-top: 0;
  }
`;

export const StyledPaymentBlock = styled.div<{ isAllowedVisitorsExist: boolean }>`
  height: ${({ isAllowedVisitorsExist }) => (isAllowedVisitorsExist ? 'initial' : '60px')};
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: space-around;
  max-width: 100%;
  overflow-x: hidden;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const StyledPaymentMethod = styled(PaymentMethod)`
  margin-bottom: 5px;
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;
export const ErrorLabel = styled.div`
  font: italic 12px/17px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.$adminPink};
`;

export const NativeErrorLabel = styled.div`
  font: italic 14px/22px ${({ theme }) => theme.fonts.join()};
  color: ${({ theme }) => theme.colors.$adminPink};
`;

export const ErrorWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
`;

export const StyledErrorIcon = styled(ExclamationMark)`
  margin: 0 5px;
  flex-shrink: 0;
`;

export const StyledNativePaymentIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.$white};
  margin-top: -4px;
`;

export const StyledAfterPaymentMethod = styled.div`
  font: italic 14px/22px ${({ theme }) => theme.fonts.join()};

  svg {
    vertical-align: middle;
    margin-right: 4px;
  }
`;
